import { render } from "./CardServiceHistory.vue?vue&type=template&id=23bb9e17&scoped=true"
import script from "./CardServiceHistory.vue?vue&type=script&lang=js"
export * from "./CardServiceHistory.vue?vue&type=script&lang=js"

import "./CardServiceHistory.vue?vue&type=style&index=0&id=23bb9e17&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bb9e17"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
